import type { ApiSearchQuery } from "@/lib/api/api-type-helper";
import { createTabFilterVisibilityState } from "@/lib/listPage";

export const TAB_FILTER = {
  FOLLOWING: "FOLLOWING",
  NO_WORKER: "NO_WORKER",
  VIOLATED: "VIOLATED",
  VIOLATED_ROLE: "VIOLATED_ROLE",
  NO_USER: "NO_USER",
  INACTIVE: "INACTIVE",
  ALUMNI: "ALUMNI",
  ALL: "ALL",
} as const;

export type TAB_FILTER = (typeof TAB_FILTER)[keyof typeof TAB_FILTER];

type QUERY = ApiSearchQuery<"/v3/app-integrations/{id}/users", "get">;
type ORDER_BY = Exclude<QUERY, undefined>["orderBy"];
export type ORDER_BY_FILTER = Exclude<ORDER_BY, undefined>;

export const SortColumns = {
  APP: "APP",
  USER: "USER",
  PERSON: "PERSON",
  CREATED_AT: "CREATED_AT",
  DEACTIVATED_AT: "DEACTIVATED_AT",
  LAST_SIGNED_IN_AT: "LAST_SIGNED_IN_AT",
  APP_USER_ROLE: "APP_USER_ROLE",
  APP_ASSIGNED_ROLE: "APP_ASSIGNED_ROLE",
  APP_USER_STATUS: "APP_USER_STATUS",
} as const satisfies Record<string, ORDER_BY_FILTER>;

export const ColumnsToSortColumns = {
  app: "APP",
  user: "USER",
  person: "PERSON",
  roleName: "APP_USER_ROLE",
  assignedRoleName: "APP_ASSIGNED_ROLE",
  statusName: "APP_USER_STATUS",
  createdAt: "CREATED_AT",
  deactivatedAt: "DEACTIVATED_AT",
  lastSignedInAt: "LAST_SIGNED_IN_AT",
} as const satisfies Record<string, ORDER_BY_FILTER>;

export const SortColumnsToColumns = {
  APP: "app",
  USER: "user",
  PERSON: "person",
  APP_USER_ROLE: "roleName",
  APP_ASSIGNED_ROLE: "assignedRoleName",
  APP_USER_STATUS: "statusName",
  BILLING_ACTIVE: "billingActive",
  CREATED_AT: "createdAt",
  DEACTIVATED_AT: "deactivatedAt",
  LAST_SIGNED_IN_AT: "lastSignedInAt",
} as const satisfies Record<ORDER_BY_FILTER, string>;

export const TAB_FILTER_VISIBILITY_STATES = createTabFilterVisibilityState({
  columns: [
    "person",
    "action",
    "rule",
    "user",
    "created_at",
    "deactivated_at",
    "lastSignedInAt",
    "actions",
  ],
  permanentColumns: [
    "rule",
    "person",
    "created_at",
    "deactivated_at",
    "lastSignedInAt",
    "user",
    "actions",
  ],
  tabFilterToColumns: {
    [TAB_FILTER.FOLLOWING]: [],
    [TAB_FILTER.NO_WORKER]: ["action"],
    [TAB_FILTER.VIOLATED]: ["action"],
    [TAB_FILTER.VIOLATED_ROLE]: ["action"],
    [TAB_FILTER.NO_USER]: ["action"],
    [TAB_FILTER.INACTIVE]: ["action"],
    [TAB_FILTER.ALUMNI]: ["action"],
    [TAB_FILTER.ALL]: ["action"],
  },
});
